import React from 'react';
import { Card } from 'primereact/card';

export default function SettingsPage() {
  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginTop: 0 }}>Settings</h2>
      <Card className="cyber-card">
        <p style={{ margin: 0 }}>Theme, notifications, and user preferences will go here.</p>
      </Card>
    </div>
  );
}